import moment from 'moment';
import React from 'react';
import { Col, Container, Row } from 'react-grid-system';

import { TenancyOrderWithActions } from '../../../redux/selectors';
import IdentifierValue from '../../IdentifierValue';
import { Table, Tbody, Td, Th, Tr } from '../../Table';
import RepositActorLink from '../RepositActorLink';
import RepositCard from '../RepositCard';

interface RepositAdditionalInformationProps {
  tenancyOrder: TenancyOrderWithActions;
}

const RepositAdditionalInformation: React.FC<RepositAdditionalInformationProps> = ({ tenancyOrder }) => {
  const checkoutDate = tenancyOrder.tenancy.checkout && tenancyOrder.tenancy.checkout.createdAt;
  const completedAt = tenancyOrder.order && tenancyOrder.order.completedAt;
  const createdAt = tenancyOrder.createdAt;
  const deletedAt = tenancyOrder.deletedAt;
  const deactivationReason = tenancyOrder.deactivationReason;
  const { legacyId, topUpEnabled } = tenancyOrder.tenancy;
  const { hasExtendedOutcomeDeadline } = tenancyOrder.tenancy;

  const info: { key: string; value: React.ReactNode }[] = [
    { key: 'Tenancy ID', value: <IdentifierValue>{tenancyOrder.tenancy.id}</IdentifierValue> },
    { key: 'Outcome Deadline Extended', value: `${hasExtendedOutcomeDeadline}` },
    { key: 'Annual Fee Collection Enabled', value: `${topUpEnabled}` },
  ];

  if (createdAt) {
    info.push({
      key: 'Created At',
      value: moment(createdAt).format('DD/MM/YYYY HH:mm'),
    });
  }

  if (checkoutDate) {
    info.push({
      key: 'Checkout Date',
      value: moment(checkoutDate).format('DD/MM/YYYY HH:mm'),
    });
    info.push({
      key: 'Checked out by',
      value: <RepositActorLink user={tenancyOrder.tenancy.checkout && tenancyOrder.tenancy.checkout.actionedByUser} />,
    });
  }

  if (completedAt) {
    info.push({
      key: 'Completed At',
      value: moment(completedAt).format('DD/MM/YYYY HH:mm'),
    });
  }

  if (deletedAt) {
    info.push({
      key: 'Deleted At',
      value: moment(deletedAt).format('DD/MM/YYYY HH:mm'),
    });
    info.push({
      key: 'Deactivation Reason',
      value: deactivationReason ? deactivationReason : '(No reason was provided for this Reposit deactivation.)',
    });
    info.push({
      key: 'Deactivated by',
      value: <RepositActorLink user={tenancyOrder.deactivatedByUser} />,
    });
  }

  if (legacyId) {
    info.push({
      key: 'Legacy ID',
      value: <IdentifierValue>{legacyId}</IdentifierValue>,
    });
  }

  return (
    <RepositCard title="Additional Information">
      <Container>
        <Row>
          <Col lg={12} style={{ padding: 0 }}>
            <Table>
              <Tbody>
                {info.map((item) => (
                  <Tr key={item.key}>
                    <Th width={250}>{item.key}</Th>
                    <Td style={{ paddingLeft: 10 }}>{item.value}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </RepositCard>
  );
};

export default RepositAdditionalInformation;
